<template>
  <section class="flex-column">
    <router-link
      v-if="referrer.id"
      :to="{path:'/accounts/detail',query:{customer_id:referrer.id}}"
      class="flex flex-wrap text-decoration-none">
      <span
        class="referrer"
        :class="{'unname':!referrerName}"
        @click="handlerUser(referrer.id)">
        {{referrerName||'Unnamed Account '}}
      </span>
    </router-link>
    <p
      v-if="referrer.send_mobile"
      class="color-gray tip mg-b-5">{{referrer.send_mobile}}</p>
    <div class="tags">
      <span
        v-if="referrer.is_tier_base"
        class="span-status blue">
        Professional
      </span>
      <span
        v-if="referrer.verify_language"
        class="span-status"
        :class="{
          'verified': referrer.verified == 20,
          'pending_verify ': referrer.verified == -1,
          'not_verify': referrer.verified == -2
        }">
        {{ referrer.verify_language }}
      </span>
      <span
        v-if="referrer.is_flagged"
        class="span-status flag">
        Flagged
      </span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'referrer-info',
  props:{
    referrer:{
      type:[Object,String],
      default:''
    }
  },
  computed:{
    referrerName(){
      let {identity,isrd_com_nm,isrd_lst_nm,isrd_fst_nm} = this.referrer||{}
      if(identity==2)
        return isrd_com_nm||''
      if(!isrd_lst_nm&&!isrd_fst_nm)
        return ''
      return `${isrd_lst_nm} ${isrd_fst_nm}`
    },
  },
  methods:{
    handlerUser(id){
      if(id){
        this.$router.push({
          path:'/accounts/detail',
          query:{
            customer_id:id
          }
        })
      }
    },
  }
}
</script>

<style scoped lang="scss">
.unname{
  font-style:italic;
  font-weight: normal!important;
}
</style>